import { Form, Formik, FormikHelpers } from 'formik'
import React from 'react'
import { object, string } from 'yup'
import ResetPasswordForm from './ResetPasswordForm'
import { Dialog } from '@mui/material'
import { useResetPasswordMutation } from 'src/services/AuthServices'
import { showToast } from 'src/utils/showToaster'

type Props = {
  userId: any
  onClose: any
}
const ResetPasswordFormWrapper = ({ userId, onClose }: Props) => {
  const [changePassword] = useResetPasswordMutation();

  const initialValues: any = {
    password: "",
  };

  const validationSchema = object({
    password: string().required("Password is required"),
  });

  // Handle Submit
  const handleSubmit = (
    values: any,
    { setSubmitting, resetForm }: FormikHelpers<any>
  ) => {
    changePassword({ id: userId, body: values }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };


  return (
    <>
      <Dialog open maxWidth="xs" fullWidth>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <Form>
              <ResetPasswordForm
                formikProps={formikProps}
                onClose={onClose}
              />
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  )
}

export default ResetPasswordFormWrapper
